import debug from 'debug';

const log = debug('PriceHelper');

class PriceHelper {

	constructor() {}

	/**
	 * Format a given price number as a string with proper suffix
	 *
	 * @param {number} price
	 * @returns {string} The formatted string
	 */
	Format(price) {

		if (!price) {
			log('No price given!');
			return "";
		}

		let suffix = '';

		price = price.toString();

		// Legacy Sitecore apis return prices as a string already formatted
		if (price.indexOf(',') !== -1) {
			return price;
		}

		if (price.indexOf('.') === -1) {
			suffix = ',-';
		}
		else {
			price = price.replace('.', ',');

			// Should we pad the price with a 0, ie. the given price is 29,9
			if (price.split(',')[1].length === 1) {
				price = price + '0';
			}
		}

		return `${price}${suffix}`;
	}
}

export default PriceHelper;
